

















































































































































import BasicTs from '@/components/mixins/basicts.vue'
import moment from "moment-timezone";
import { Component, Mixins } from 'vue-property-decorator'
import * as types from '@/lib/definition/types'
import { BotInfo, BrowserInfo, detect, NodeInfo, SearchBotDeviceInfo } from 'detect-browser'
moment.locale('ja')

@Component({
  mixins: [BasicTs]
})
export default class Projects extends Mixins(BasicTs) {
  private projects = new Array<types.ProjectAssignByProjectParamLocal>()
  private assignByUsers = new Array<types.ProjectAssignByUserParamLocal>()
  private users = new Array<types.ProjectAssignByProjectParamUserLocal>()
  private addingUsers = new Array<types.ProjectAssignByProjectParamUser>()
  private addingObj: types.ProjectAssignByProjectParamLocal = this.$store.direct.getters.ProjectAssign.emptyProject
  private addingAssignObj: types.ProjectAssignByProjectParamAssignLocal = this.$store.direct.getters.ProjectAssign.emptyProjectAssign

  private tab = 0

  private dialogAdding = false
  private dialogDeleting = false
  private requestParam: any = null
  private browser:  any = detect()
  private dateStyle = ''
  private timeStyle = ''
  private validAssignForm = false
  async mounted() {
    this.browser = detect()
    if (this.browser !== null) {
      if ((this.browser?.os?.includes('iOS') ?? false) || (this.browser?.os?.includes('Android') ?? false)) {
        this.dateStyle = 'input'
        this.timeStyle = 'time'
      }
    }
  }

  async masterReady () {
    if (!this.$store.getters['Login/isAdmin']) {
      // redirect to home when you are not admin
      this.$router.push(this.site.deployFolder + "/")
    }
    this.users = await this.$store.direct.dispatch.ProjectAssign.listAllUser()
    this.users.push({appUserId:'', displayName:'',supplimentalName:'',displayNameWithSupplimentalName:''})
    await this.search()
  }
  async search () {
    if (this.tab==0) {
      this.projects = await this.$store.direct.dispatch.ProjectAssign.listAll()
    }else{
      this.assignByUsers = await this.$store.direct.dispatch.ProjectAssign.listAllByUser()
    }
  }
  prepareToDelete (item: types.ProjectParamWithLocalDate) {
    this.dialogDeleting = true
  }
  prepareToEdit (item: types.ProjectParamWithLocalDate) {
    this.addingObj = JSON.parse(JSON.stringify(item)) 
    this.dialogAdding = true
    this.addingAssignObj.projectId = item.projectId ?? ''
    this.addingAssignObj.appUserId = ''
    this.addingAssignObj.startDateLocal = moment().format('YYYY-MM-DD')
    this.addingAssignObj.lastDateLocal = null
    this.addingUsers = this.users.filter(obj => {
      return !this.addingObj.assigns.reduce((prev:boolean , current:types.ProjectAssignByProjectParamAssignLocal) => {
        return prev || current.appUserId == obj.appUserId
      },false)
    })
  }
  async confirmAdding () {
    this.dialogAdding = false
    this.requestParam = this.addingObj
    this.requestParam.isPersonal = false
    await this.$store.direct.dispatch.Project.add(this.requestParam);
    this.dispSuccess('アサインを追加しました')
    this.search()
  }
  async checkDateAndTime(object: types.ProjectParamWithLocalDate) {
      var startDate = (object.startDateLocal == null || object.startDateLocal == '') ? null : moment(object.startDateLocal)
      var endedDate =  (object.endDateLocal == null || object.endDateLocal == '') ? null : moment(object.endDateLocal)
  }
  async addAssign() {
    if (this.addingAssignObj.appUserId == '') {
      this.dispError('ユーザー名を入力してください')
      return
    }

    await this.$store.direct.dispatch.ProjectAssign.addAssign(this.addingAssignObj)
    await this.search()
    var projectId = this.addingObj.projectId
    this.addingObj = this.projects.reduce((prev:types.ProjectAssignByProjectParamLocal|null, obj:types.ProjectAssignByProjectParamLocal)=>{return prev != null ? prev : (obj.projectId == projectId ? obj : null)}, null) ?? this.$store.direct.getters.ProjectAssign.emptyProject
    this.addingAssignObj.appUserId = ''
    this.addingAssignObj.startDateLocal = moment().format('YYYY-MM-DD')
    this.addingAssignObj.lastDateLocal = null
    this.validAssignForm = true
  }
  async finishAssign(item: types.ProjectAssignByProjectParamAssignLocal) {
    item.enabled = false
    item.lastDateLocal = moment().format('YYYY-MM-DD')
    await this.$store.direct.dispatch.ProjectAssign.addAssign(item)
    await this.search()
    var projectId = this.addingObj.projectId
    this.addingObj = this.projects.reduce((prev:types.ProjectAssignByProjectParamLocal|null, obj:types.ProjectAssignByProjectParamLocal)=>{return prev != null ? prev : (obj.projectId == projectId ? obj : null)}, null) ?? this.$store.direct.getters.ProjectAssign.emptyProject
  }
  async updateDate(item: types.ProjectAssignByProjectParamAssignLocal) {
    await this.$store.direct.dispatch.ProjectAssign.addAssign(item)
    await this.search()
    var projectId = this.addingObj.projectId
    this.addingObj = this.projects.reduce((prev:types.ProjectAssignByProjectParamLocal|null, obj:types.ProjectAssignByProjectParamLocal)=>{return prev != null ? prev : (obj.projectId == projectId ? obj : null)}, null) ?? this.$store.direct.getters.ProjectAssign.emptyProject
    this.dispSuccess('プロジェクトを更新しました')
  }
  async makeActive(item: types.ProjectAssignByUserParamProjectLocal) {
    if (item.isCurrent) {
      this.dispError('すでにアクティブです')
      return
    }
    await this.$store.direct.dispatch.ProjectAssign.makeActive(item)
    await this.search()
  }
}
